const QueueColors = {
  normal: [1, 107, 146, 0.815],
  danger: [134, 1, 16, 0.815],
  success: [0, 129, 0, 0.815],
  custom_1: [252, 221, 81, 0.815],
  custom_2: [240, 91, 65, 0.815],
  custom_3: [67, 165, 250, 0.815],
  custom_4: [195, 67, 250, 0.815],
  custom_5: [186, 115, 80, 0.815],
  custom_6: [255, 112, 215, 0.815],
  default: [71, 71, 71, 0.815],
};

export const getQueueTextByBackgroundColor = (backgroundColorName: string) => {
  let color = QueueColors[backgroundColorName];
  const weightedDistanceIn3D = Math.sqrt(
    Math.pow(color[0], 2) * 0.241 + Math.pow(color[1], 2) * 0.691 + Math.pow(color[2], 2) * 0.068,
  );

  return weightedDistanceIn3D < 130 ? [255, 255, 255, 1] : [0, 0, 0, 1];
};
